<div class="ai-quote-chat-input-container" [ngClass]="{'mobile-ai-quote-chat-input-container': isMobileApp}">

  <!--Input to upload files for web view-->
  @if (!isMobileApp) {
    <ng-container [ngTemplateOutlet]="fileUploadTemplate">
    </ng-container>
  }

  <!-- Textarea for input field -->
  <div class="desktop-textarea-container" [ngClass]="{'files-added': selectedFiles.length > 0}">
    <!-- IMAGE STRIP (inside pill, above textarea) -->
    @if (selectedFiles.length) {
      <div class="desktop-image-strip">
        @if (showLeftArrow) {
          <div class="strip-arrow left" (click)="scrollLeft()">
            <i class="fa fa-angle-left nav-icon"></i>
          </div>
        }
        <div class="strip-viewport" #imageViewport>
          <div class="strip-scroller" #imageScroller>
            @for (img of selectedFiles; track img; let i = $index) {
              <div class="strip-thumb desktop-thumb"
                [customTooltip]="img.file.name" tooltipPosition="top" tooltipTrigger="hover"
                [tooltipMaxWidth]="'260px'">
                @if (img.isImage) {
                  <img [src]="img.preview" [alt]="img.file.name" />
                }
                <button type="button" class="thumb-remove" id="thumb-btn" (click)="removeImage(i)">
                  <i class="fa fa-times"></i>
                </button>
                @if (!img.isImage) {
                  <div class="file-preview-card">
                    <div class="file-preview-icon">
                      <svg width="21" height="28" viewBox="0 0 21 28" fill="none"
                        xmlns="http://www.w3.org/2000/svg" role="img"
                        [attr.aria-label]="img.typeLabel + ' file'">
                        <path
                          d="M12.25 7.4375C12.25 8.20312 12.7969 8.75 13.5625 8.75H21V26.6875C21 27.4531 20.3984 28 19.6875 28H1.3125C0.546875 28 0 27.4531 0 26.6875V1.3125C0 0.601562 0.546875 0 1.3125 0H12.25V7.4375ZM21 6.67187V7H14V0H14.3281C14.6562 0 14.9844 0.164062 15.2578 0.382812L20.6172 5.74219C20.8359 6.01562 21 6.34375 21 6.67187Z" />
                      </svg>
                    </div>
                    <div class="file-preview-meta">
                      <div class="file-preview-name">{{ img.file.name }}</div>
                      <div class="file-preview-size-lable">
                        <div class="file-preview-type">{{ img.typeLabel }}</div>
                        <div class="separator">•</div>
                        <div class="file-preview-size">{{ img.sizeLabel }}</div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        @if (showRightArrow) {
          <div class="strip-arrow right" (click)="scrollRight()">
            <i class="fa fa-angle-right nav-icon"></i>
          </div>
        }
      </div>
    }

    <!-- Textarea -->
    <div class="desktop-textarea-row">
      <!--Input to upload files for mobile view-->
      @if (isMobileApp) {
        <ng-container [ngTemplateOutlet]="fileUploadTemplate">
        </ng-container>
      }

      <textarea #inputElementText maxlength="1000" [ngClass]="{ 'input-disabled': (loading || disableInput) }"
        [disabled]="loading || disableInput" placeholder="Ask me anything" (input)="onInputChangeTextArea($event)"
      (keydown)="onKeyDown($event)" rows="1"></textarea>

      <!-- Microphone -->
      <button (click)="onToggleMic()" class="mic-button-embedded" [disabled]="disableInput || loading"
        [ngClass]="{'mic-enabled': (micEnabled && isMobileApp)}">
        <!-- Enabled -->
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
          [ngClass]="{'microphone-active': micEnabled}">
          <path
            d="M10.0004 12.9829C11.6436 12.9829 12.9757 11.6474 12.9757 9.99996V5.02836C12.9757 3.3809 11.6436 2.04541 10.0004 2.04541C8.35726 2.04541 7.02524 3.3809 7.02524 5.02836V9.99996C7.02524 11.6474 8.35726 12.9829 10.0004 12.9829ZM14.9591 8.01132H14.4633C14.1893 8.01132 13.9674 8.2338 13.9674 8.50848V9.99996C13.9674 12.3242 11.9687 14.1891 9.60406 13.958C7.54311 13.7563 6.0335 11.8988 6.0335 9.82284V8.50848C6.0335 8.2338 5.8116 8.01132 5.53763 8.01132H5.04177C4.7678 8.01132 4.5459 8.2338 4.5459 8.50848V9.75635C4.5459 12.5417 6.52844 15.0247 9.25664 15.4019V16.463H7.5211C7.24714 16.463 7.02524 16.6855 7.02524 16.9602V17.4573C7.02524 17.732 7.24714 17.9545 7.5211 17.9545H12.4798C12.7537 17.9545 12.9757 17.732 12.9757 17.4573V16.9602C12.9757 16.6855 12.7537 16.463 12.4798 16.463H10.7442V15.4137C13.4005 15.0483 15.455 12.7623 15.455 9.99996V8.50848C15.455 8.2338 15.2331 8.01132 14.9591 8.01132Z"
            fill="var(--primary)" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Send Icon -->
  <div class="ai-quote-send-icon-container">
    <svg [ngClass]="{'disable-send-icon': disableInput || loading || (!getInputText() && getSelectedFiles().length === 0)}" (click)="sendMessage()"
      width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fill="var(--primary)"
        d="M2.74323 16.5979L3.97181 11.2776C4.02031 11.0512 4.21429 10.8733 4.45678 10.8409L11.3271 10.1294C11.5211 10.1132 11.5211 9.82214 11.3271 9.7898L4.45678 9.12677C4.21429 9.1106 4.02031 8.93271 3.97181 8.70631L2.74323 3.4021C2.63007 2.94931 3.11504 2.57736 3.53534 2.78759L16.9689 9.51488C17.3731 9.72511 17.3731 10.3073 16.9689 10.5175L3.53534 17.2125C3.11504 17.4227 2.63007 17.0507 2.74323 16.5979Z" />
    </svg>
  </div>
</div>

<!-- Camera Dialog -->
@if (showCameraDialog) {
  <app-chat-camera-dialog [isMobileApp]="isMobileApp" (capture)="onCaptureImage($event)"
  (close)="onCloseCameraDialog()"></app-chat-camera-dialog>
}


<ng-template #fileUploadTemplate>
  <div class="file-upload">
    <input [disabled]="disableInput" class="file-input" type="file" (change)="onFilesSelected($event)" #fileUpload
      multiple [attr.capture]="(isMobileApp && isAndroid) ? 'environment' : null" />

    <button [disabled]="loading || disableInput || isFileUploadLimitReached"
      [customTooltip]="!showUploadOptions ? uploadLimitTooltip : null" tooltipPosition="top-start"
      [tooltipTrigger]="isMobileApp? 'longpress': 'hover'" [tooltipMaxWidth]="'260px'" class="chat-button upload-button"
      (click)="onClickUpload('upload')">
      @if (showUploadOptions && !isMobileApp) {
        <svg width="20" height="20" viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.7197 3.80134C14.1588 3.36226 14.9336 3.36226 15.3727 3.80134L16.1992 4.62783C16.6641 5.09273 16.6383 5.84173 16.1992 6.2808L12.48 10L16.1992 13.7192C16.6641 14.1841 16.6383 14.9331 16.1992 15.3722L15.3727 16.1987C14.9078 16.6636 14.1846 16.6636 13.7197 16.1987L10.0005 12.4795L6.28133 16.1987C5.81643 16.6636 5.09325 16.6636 4.62835 16.1987L3.80186 15.3722C3.36279 14.9331 3.33696 14.1841 3.80186 13.7192L7.52106 10L3.80186 6.2808C3.36279 5.84173 3.33696 5.09273 3.80186 4.62783L4.62835 3.80134C5.06742 3.36226 5.84226 3.36227 6.28133 3.80134L10.0005 7.52053L13.7197 3.80134Z"
            fill="var(--primary)" />
        </svg>
      } @else {
        <svg width="20" height="20" viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.0129 8.24669C17.6339 8.24669 18.1818 8.79458 18.1818 9.41552V10.5843C18.1818 11.2418 17.6339 11.7532 17.0129 11.7532H11.7532V17.0129C11.7532 17.6704 11.2053 18.1818 10.5843 18.1818H9.41552C8.75805 18.1818 8.24669 17.6704 8.24669 17.0129V11.7532H2.98695C2.32948 11.7532 1.81812 11.2418 1.81812 10.5843V9.41552C1.81812 8.79458 2.32948 8.24669 2.98695 8.24669H8.24669V2.98695C8.24669 2.366 8.75805 1.81812 9.41552 1.81812H10.5843C11.2053 1.81812 11.7532 2.366 11.7532 2.98695V8.24669H17.0129Z"
            fill="var(--primary)" />
        </svg>
      }
    </button>

    @if (showUploadOptions && !isMobileApp) {
      <div class="upload-options-dialog">
        <div class="upload-options">
          <div (click)="onOpenCameraDialog()" class="upload-option">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M25.4545 12V22.2857C25.4545 23.25 24.642 24 23.6818 24H8.31814C7.32098 24 6.54541 23.25 6.54541 22.2857V12C6.54541 11.0714 7.32098 10.2857 8.31814 10.2857H11.5681L12.0113 9.14286C12.2698 8.46429 12.9346 8 13.6733 8H18.2897C19.0284 8 19.6931 8.46429 19.9517 9.14286L20.4318 10.2857H23.6818C24.642 10.2857 25.4545 11.0714 25.4545 12ZM20.4318 17.1429C20.4318 14.7857 18.4375 12.8571 16 12.8571C13.5255 12.8571 11.5681 14.7857 11.5681 17.1429C11.5681 19.5357 13.5255 21.4286 16 21.4286C18.4375 21.4286 20.4318 19.5357 20.4318 17.1429ZM19.25 17.1429C19.25 18.8929 17.7727 20.2857 16 20.2857C14.1903 20.2857 12.75 18.8929 12.75 17.1429C12.75 15.4286 14.1903 14 16 14C17.7727 14 19.25 15.4286 19.25 17.1429Z"
                fill="currentColor" />
            </svg>
          </div>
          <div (click)=" onUploadFile()" class="upload-option">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.5587 10.3864C19.7753 9.60297 18.5038 9.60297 17.7204 10.3864L11.8126 16.2942C10.4609 17.6459 10.4609 19.8357 11.8126 21.1874C13.1644 22.5391 15.3541 22.5391 16.7058 21.1874L21.5862 16.307C21.9361 15.9571 22.5077 15.9571 22.8576 16.307C23.2076 16.657 23.2076 17.2285 22.8576 17.5785L17.9773 22.4588C15.9224 24.5137 12.596 24.5137 10.5412 22.4588C8.48628 20.404 8.48628 17.0776 10.5412 15.0227L16.449 9.11494C17.9355 7.62835 20.3436 7.62835 21.8302 9.11494C23.3168 10.6015 23.3168 13.0096 21.8302 14.4962L16.1793 20.1471C15.261 21.0654 13.7712 21.0654 12.8529 20.1471C11.9346 19.2288 11.9346 17.739 12.8529 16.8208L17.4764 12.1973C17.8264 11.8473 18.3979 11.8473 18.7479 12.1973C19.0978 12.5472 19.0978 13.1187 18.7479 13.4687L14.1244 18.0922C13.9092 18.3073 13.9092 18.6605 14.1244 18.8756C14.3395 19.0908 14.6927 19.0908 14.9078 18.8756L20.5587 13.2247C21.3421 12.4413 21.3421 11.1698 20.5587 10.3864Z"
                fill="currentColor" />
            </svg>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>